import { render, staticRenderFns } from "./ConfirmDeleteDialog.vue?vue&type=template&id=1c6ca233&"
import script from "./ConfirmDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6ca233')) {
      api.createRecord('1c6ca233', component.options)
    } else {
      api.reload('1c6ca233', component.options)
    }
    module.hot.accept("./ConfirmDeleteDialog.vue?vue&type=template&id=1c6ca233&", function () {
      api.rerender('1c6ca233', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ConfirmDeleteDialog.vue"
export default component.exports